module.exports = __webpack_public_path__ + "img/logo.7080a6ba.png";